const bodyScrollLock = require('body-scroll-lock');

function openBookCardPopup() {
    let element = document.querySelector('.bn_contest__popup-overlay');

    bodyScrollLock.disableBodyScroll(element, {reserveScrollBarGap: true});

    $('.bn_contest__popup-overlay').addClass('open');

    $('body').addClass('modal-open');
}

function closeBookCardPopup () {
    $('.bn_contest__popup-overlay').removeClass('open');

    bodyScrollLock.clearAllBodyScrollLocks();

    $('body').removeClass('modal-open');
}

$(document).on('click', '.bn_contest__popup-close, .bn_contest__popup-decline', function () {
    closeBookCardPopup();
});

$(document).on('click', '.bn_contest__popup-overlay', function (event) {
    if ($(event.target).closest('.bn_contest__popup-wrapper').length) return;

    if (!$(this).hasClass('open')) return;

    closeBookCardPopup();
});

$(document).on('click', '.bn_contest__get-popup', function () {
    let that = $(this),
        wrapper = $('body'),
        contestId = that.data('contest');

    $.ajax({
        'type': 'POST',
        'url': '/contests/render-popup-add-book',
        'data': {contestId: contestId},
        'beforeSend': function () {
            $('.bn_contest__popup').remove();
        },
        'success': function (result) {
            wrapper.append(result);

            initCustomDropdown();

            initScrollbar();

            openBookCardPopup();
        },
        'error': function () {
            console.error('BookCard popup ajax error')
        },
    });
})

$(document).on('click', '.bn_contest__popup-accept', function () {
    let error = $('.bn_contest__popup-form-error'),
        agreement = $('#agreement'),
        select = $('.bn_contest__popup-form-select'),
        bookId = select.val();

    error.html('');

    if (bookId == 0) {
        error.html($('select[name="select_publication_book"] option:selected').text());
        return false;
    }

    if (!agreement.prop('checked')) {
        error.text(agreement.data('error'));
        return false;
    }
    var btn = $(this);
    btn.prop('disabled', true).addClass('ln_disabled');

    $.ajax({
        url: '/contests/add-book-contests',
        type: "post",
        dataType: "json",
        data: {
            contestsId: $('#contestsId').val(),
            bookId: bookId,
        },
        success: function (response) {
            if (response.error != undefined) {
                error.html(response.error);
            } else {
                window.location.reload();
            }
        },
        complete: function (response) {
            btn.prop('disabled', false).removeClass('ln_disabled');
        }
    });

    return false;
});

$(document).on('click', '.bn_book-row__vert-item-contest-menu-button', function () {
    let that = $(this),
        container = that.parents('.bn_book-row__vert-item-contest-menu'),
        menu = container.find('.bn_book-row__vert-item-contest-menu-dropdown'),
        menuDom = menu.get(0);

    menu.removeClass('position-top');

    $('.bn_book-row__vert-item-contest-menu-button').not(that).parents('.bn_book-row__vert-item-contest-menu').removeClass('open');

    container.toggleClass('open')

    if (window.innerHeight - menuDom.getBoundingClientRect().bottom < 10) {
        menu.addClass('position-top')
    }

    $(document).on('click', function (event) {
        if ($(event.target).closest('.bn_book-row__vert-item-contest-menu-button, .bn_book-row__vert-item-contest-menu-dropdown').length) return;

        $('.bn_book-row__vert-item-contest-menu').removeClass('open');
    });
});

$(document).on('change', '.bn_contest__form-dynamic input, .bn_contest__form-dynamic select', function () {
    $('.bn_contest__form-dynamic').submit();
});